<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("FnB Sales Combo Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
                :multiple="false"
                :taggable="true"
              ></multiselect>
            </div>
          </div>

          <!--Transaction From & To date-->

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="transaction_from_date"
                  >✖</button
                >
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="transaction_from_date"
                  v-validate="'required'"
                  @selected="onChangeDate_transaction($event, 'from')"
                ></Datepicker>
                <label :class="transaction_from_date ? 'active' : ''">
                  {{ $t("transaction") }} {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="transaction_to_date"
                  >✖</button
                >
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="transaction_to_date"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="transaction_to_date ? 'active' : ''"
                  >{{ $t("transaction") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>
          <!--Transaction From & To date End-->
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate_showDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-1 align-self-center mb-3">
            <button
              class="btn-blue-lg"
              @click.prevent="getFnBComboReportData"
              style="min-width: 85px !important;"
            >
              {{ $t("fetch") }}
              <!-- {{ $t("report") }} -->
            </button>
          </div>

          <div
            v-if="getFnBComboReport.length > 0"
            class="col-lg-6 col-xl-12 align-self-center mt-2 d-flex justify-content-end align-items-center"
          >
            <span class="mx-1">Download as</span>
            <img
              class=""
              @click="getFnBComboReportData({ isPdf: 'Y' })"
              src="@/assets/img/icons/pdf.svg"
              height="25"
              width="25"
              style="cursor: pointer"
            />
            <img
              class=""
              @click="excelDownload()"
              src="@/assets/img/icons/excel.svg"
              height="25"
              width="25"
              style="cursor: pointer"
            />
          </div>
          <!-- <div
          class="d-flex justify-content-end mt-5 align-items-center"
          v-if="getFnBComboReport.length"
        >
          <div>{{ $t("download") }} as:</div>
          <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a href="#" @click="excelDownload()" title="Download as Excel">
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div> -->
        </div>
      </div>

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="getFnBComboReport.length > 0"
          >
            <thead class="bg-lightblue font-weight-bold text-light">
              <!-- <th>Cinema Name</th> -->
              <th>Date</th>
              <th>Item Code</th>
              <th>Combo Item Name</th>
              <th>Combo Items</th>
              <th>Qty</th>
              <th>Item Cost with VAT</th>
              <th>Single Item Cost</th>
              <th>Combo Single Price</th>
              <th>Combo Selling Price</th>
              <th>Value Pack Single Item Price</th>
              <th>Discount Value</th>
            </thead>
            <tbody>
              <template
                v-for="(fnbComboData, fnbComboDataIndex) in getFnBComboReport"
              >
                <tr :key="fnbComboDataIndex + 'fnb_cinema_name'">
                  <td colspan="11" class="bg-lightgrey font-weight-bold">
                    {{ fnbComboData.cinema_name }}
                  </td>
                </tr>
                <template
                  v-for="(fnbDate, fnbDateIndex) in fnbComboData.dateObj"
                >
                  <tr :key="fnbDateIndex + 'fnb_date_date'">
                    <td
                      :rowspan="fnbDate.dateObjRowspan + 1"
                      v-if="fnbDate.dateBasedData.length > 0"
                    >
                      {{ fnbDate.date }}
                    </td>
                    <!-- <td v-if="fnbDate.dateBasedData.length > 1"></td> -->
                  </tr>

                  <template
                    v-for="(fnbbaseDate,
                    fnbbaseDateIndex) in fnbDate.dateBasedData"
                  >
                    <tr :key="fnbbaseDateIndex + 'fnb_datebase'">
                      <!-- <td v-if="fnbDate.dateBasedData.length > 1"></td> -->
                      <td
                        :rowspan="fnbbaseDate.comboItemsRowspan"
                        class="text-left"
                      >
                        {{ fnbbaseDate.item_code }}
                      </td>
                      <td
                        :rowspan="fnbbaseDate.comboItemsRowspan"
                        class="text-left"
                      >
                        {{ fnbbaseDate.fst_item_name }} &nbsp;{{
                          fnbbaseDate.fst_quantity
                            ? "(" + fnbbaseDate.fst_quantity + " qty)"
                            : ""
                        }}
                      </td>
                    </tr>
                    <tr
                      v-for="(fnbSingleData,
                      fnbSingleDataIndex) in fnbbaseDate.combo_arr"
                      :key="
                        fnbSingleDataIndex +
                          'fnbSingleDataArr' +
                          fnbSingleDataIndex
                      "
                    >
                      <td class="text-left">
                        {{ fnbSingleData.item_name }}
                      </td>
                      <td class="text-right">
                        {{ fnbSingleData.quantity }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(fnbSingleData.cost_price) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(fnbSingleData.cost_price / fnbSingleData.quantity) }}
                      </td>
                      <td></td>
                      <td></td>
                      <td class="text-right">
                        {{ currFormat(fnbSingleData.value_single_item) }}
                      </td>
                      <td></td>
                      
                    </tr>
                    <tr
                      :key="fnbbaseDateIndex + 'fnbDate'"
                      class="bg-lightgrey font-weight-bold"
                    >
                      <td colspan="4">Total</td>
                      <td class="text-right">
                        {{ currFormat(fnbbaseDate.combo_cost_price) }}
                      </td>
                      <td></td>
                      <td class="text-right">
                        {{ currFormat(fnbbaseDate.combo_single_cost) }}
                      </td>
                      
                      <td class="text-right">
                        {{ currFormat(fnbbaseDate.price) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(fnbbaseDate.value_single_item_total) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(fnbbaseDate.discount_value) }}
                      </td>
                    </tr>
                  </template>
                </template>

                <tr class="bg-lightgrey font-weight-bold">
                  <td colspan="4" class="text-left">
                    <!-- Qty Total -->
                    Grand Total
                  </td>
                  <td class="bg-lightgrey text-right">
                    {{ grandTotal.quantity_Gtotal }}
                  </td>
                  <td class="bg-lightgrey text-right">
                    {{ currFormat(grandTotal.combo_cost_price_Gtotal) }}
                  </td>
                  <td></td>
                  <td class="bg-lightgrey text-right">
                    {{ currFormat(grandTotal.combo_single_cost_Gtotal) }}
                  </td>
                  <td class="bg-lightgrey text-right">
                    {{ currFormat(grandTotal.selling_price_Gtotal) }}
                  </td>
                  <td class="bg-lightgrey text-right">
                    {{ currFormat(grandTotal.value_single_item_Gtotal) }}
                  </td>
                  <td class="bg-lightgrey text-right">
                    {{ currFormat(grandTotal.discount_value_Gtotal) }}
                  </td>
                </tr>
                <!-- <tr
                  :key="fnbArrIndex + fnbComboDataIndex + 'grand_total'"
                  class="bg-lightgrey font-weight-bold"
                >
                  <td class="text-left" colspan="2">Total</td>
                  <td class="text-right">
                    {{
                      fnbComboData.fnbData.reduce(
                        (acc, { fst_quantity_total }) => {
                          return acc + fst_quantity_total;
                        },
                        0
                      )
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      fnbComboData.fnbData
                        .reduce((acc, { price }) => {
                          return acc + price;
                        }, 0)
                        .toFixed(this.MIN_FRACTION_DIGITS)
                    }}
                  </td>
                  <td class="text-right">
                    {{
                      fnbComboData.fnbData
                        .reduce((acc, { fst_quantity_total, price }) => {
                          return acc + fst_quantity_total * price;
                        }, 0)
                        .toFixed(this.MIN_FRACTION_DIGITS)
                    }}
                  </td>
                </tr> -->
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <table
        v-if="getFnBComboReport.length === 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
        <thead class="bg-lightgrey">
          <!-- <th>Cinema Name</th> -->
          <th>Date</th>
          <th>Combo</th>
          <th>Combo Items</th>
          <th>Qty</th>
          <th>Price</th>
          <th>Value</th>
        </thead>
        <tbody>
          <tr>
            <td colspan="5">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import xlsx from "json-as-xlsx";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        transaction_from_date: "",
        transaction_to_date: "",
        getFnBComboReport: [],
        getFnBComboReportRecords: [],
        Allrecords: [],
        mainArr: [],
        grandTotal: {},
        temp_excel_arr: [],
      };
    },
    beforeMount() {
      // let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
      // this.getCinemaList();
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // }
    },
    mounted() {},
    methods: {
      debouncedOnChange: _.debounce(function(query) {
        // this.transactionList = [];
        this.fromDate = "";
        this.toDate = "";
        // this.currentPage = 1;
        // this.onGetTransactionList();
      }, 500),

      onChangeDate_transaction: function(e, type){
        if(type == 'from'){
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
        this.debouncedOnChange();
      },
      debouncedOnChangeShowDate: _.debounce(function(query) {
        // this.transactionList = [];
        this.transaction_from_date = "";
        this.transaction_to_date = "";
        // this.currentPage = 1;
        // this.onGetTransactionList();
      }, 500),

      onChangeDate_showDate: function(e, type){
        if(type == 'from'){
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
        this.debouncedOnChangeShowDate();
      },
      excelDownload() {
        // let temp_data = this.Allrecords;
        // console.log(this.Allrecords);
        // let temp_arr = [];
        // temp_data.map((x) => {
        //   x.fnbData.map((y) => {
        //     y["combo_items_data"] = "";
        //     y.combo_arr.forEach((x) => {
        //       y["combo_items_data"] += y["combo_items_data"]
        //         ? `,${x.quantity}-${x.item_name}`
        //         : `${x.quantity}-${x.item_name}`;
        //     });
        //     let obj = {
        //       ...x,
        //       ...y,
        //     };
        //     temp_arr.push(obj);
        //   });
        // });
        // console.log({ temp_arr });
        let dateparse = function(value) {
          if (!value) return "-";
          else if (value === "Invalid date") return "-";
          else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
            return value
              ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
              : "-";
          //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
          //this is changed acc to mams decision
          else
            return value
              ? moment(value).format("DD-MM-YYYY") === "Invalid date"
                ? "-"
                : moment(value).format("DD-MMM-YYYY")
              : "-";
        };
        let fulldatemonparse = function(value) {
          if (!value) return "-";
          else if (value === "Invalid date") return "-";
          else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
            return value
              ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
              : "-";
          //else return value ? moment(value).format('DD-MM-YYYY') === 'Invalid date' ? '-' : moment(value).format('DD-MM-YYYY') : '-';
          //this is changed acc to mams decision
          else
            return value
              ? moment(value).format("DD-MM-YYYY") === "Invalid date"
                ? "-"
                : moment(value).format("DD-MMM-YYYY HH:mm")
              : "-";
        };

        let data = [
          {
            sheet: "Fnb Sales Report",
            columns: [
              {
                value: "cinema_name",
                label: "Cinema",
              },
              {
                value: "date",
                label: "Date",
              },
              {
                value: "item_code",
                label: "Item Code",
              },
              {
                value: "fst_item_name",
                label: "Combo",
              },
              {
                value: "combo_items_data",
                label: "Combo Items",
              },
              {
                value: "fst_quantity",
                label: "Qty",
              },
              {
                value: "price",
                label: "Price",
              },
              {
                value: "value_single_item_total",
                label: "Regular Price",
              },
              {
                value: "discount_value",
                label: "Discount Value",
              },
              {
                value: (row) =>
                  +parseFloat(
                    (row.discount_value / row.value_single_item_total) * 100
                  ).toFixed(this.MIN_FRACTION_DIGITS),
                label: "Discount %",
              },
              {
                value: (row) => row.price * row.fst_quantity,
                label: "value",
              },

              //      Sold: 0,
              // gross_amount: 0,
              // offer_price: 0,
              // total_taxes: 0,
              // final_gross_amount: 0
            ],
            content: this.temp_excel_arr,
          },
        ];
        let cinemaName = this.dropDown.selectedCinemaName;
        let fromDate = this.fromDate
          ? moment(this.fromDate).format("YYYY-MM-DD")
          : null;
        let toDate = this.toDate
          ? moment(this.toDate).format("YYYY-MM-DD")
          : null;
        var today = new Date();
        var date =
          String(today.getDate()).padStart(2, "0") +
          "-" +
          String(today.getMonth() + 1).padStart(2, "0") +
          "-" +
          today.getFullYear();
        var time =
          String(today.getHours()).padStart(2, "0") +
          ":" +
          String(today.getMinutes()).padStart(2, "0") +
          ":" +
          String(today.getSeconds()).padStart(2, "0");

        var dateTime = date + "_AT_" + time;
        let settings = {
          fileName: `FnbSalesComboReport-${cinemaName}_${fromDate}_${toDate}_on${dateTime}`,
        };
        xlsx(data, settings);
      },
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })

          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        console.log(event);
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = [event.cine_id];

        // this.$store.dispatch("selectDropdownCinema", event);
      },

      getFnBComboReportData: function({ isPdf = "N" }) {
        if (!this.dropDown.selectedCinemaId) {
          this.$toasted.show("Select Cinema");
          return;
        }

        let loader = this.$loading.show();
        this.submitted = true;
        this.getFnBComboReport = [];
        this.grandTotal = {};
        this.temp_excel_arr = [];
        // this.dataObj = this.getFnBComboReport.dataOdj;
        this.getFnBComboReportRecords = [];
        this.Allrecords = [];

        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinema.cine_name,
          cinema_address: this.dropDown.selectedCinema.cine_address,
          isShowDate: this.fromDate ? "Y" : "N",
          fromDate: this.fromDate
            ? moment(this.fromDate).format("YYYY-MM-DD")
            : this.transaction_from_date
            ? moment(this.transaction_from_date).format("YYYY-MM-DD")
            : "",
          toDate: this.toDate
            ? moment(this.toDate).format("YYYY-MM-DD")
            : this.transaction_to_date
            ? moment(this.transaction_to_date).format("YYYY-MM-DD")
            : "",
          // transaction_from_date: this.transaction_from_date
          //   ? moment(this.transaction_from_date).format("YYYY-MM-DD")
          //   : "",
          // transaction_to_date: this.transaction_to_date
          //   ? moment(this.transaction_to_date).format("YYYY-MM-DD")
          //   : "",
          isPdf,
        };
        ReportsService.GetFnBComboSalesReport(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records) {
              // console.log("data from api", data.Records);
              data.cinemaBasedData.forEach((x) => {
                x.dateObj.map((z) => {
                  // y.map((z) => {
                  // z["dateObjRowspan"] = z.dateBasedData.length;
                  z.dateBasedData.map((zz) => {
                    // zz["combo_arr"] = JSON.parse(zz.combo_data);

                    // z["dateObjRowspan"] += zz.combo_arr.length + 1;
                    // zz["comboItemsRowspan"] = zz.combo_arr.length + 1;
                    zz["combo_items_data"] = "";
                    zz.combo_arr.map((combos) => {
                      zz["combo_items_data"] += zz["combo_items_data"]
                        ? `,${combos.quantity}-${combos.item_name}`
                        : `${combos.quantity}-${combos.item_name}`;
                    });
                    let obj = {
                      cinema_name: x.cinema_name,
                      ...z,
                      ...zz,
                    };
                    this.temp_excel_arr = [...this.temp_excel_arr, obj];
                  });
                  // });
                });
              });
              this.getFnBComboReport = data.cinemaBasedData;
              this.grandTotal = { ...data.grandTotal };
              // this.dataObj = this.getFnBComboReport.dataOdj;
              this.getFnBComboReportRecords = data.orginal_Records;
              this.Allrecords = data.Records;
              if (data.pdfPath && isPdf == "Y") {
                window.open(data.pdfPath, "_blank");
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 660);
          });
      },
      // getFnBComboReportData: function() {
      //   let loader = this.$loading.show();
      //   this.submitted = true;

      //   let payload = {
      //     cinema_id: this.dropDown.selectedCinemaId,
      //     fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
      //     toDate: moment(this.toDate).format("YYYY-MM-DD")
      //   };
      //   ReportsService.GetFnBComboSalesReport(payload)
      //     .then(response => {
      //       const { data } = response;
      //       if (data.status && data.Records) {
      //         // console.log("data from api", data.Records);
      //         this.getFnBComboReport = data.Records;
      //         this.getFnBComboReportRecords = data.orginal_Records;
      //         let tempFnbRecords = this.getFnBComboReportRecords;
      //         let tempComboRecords = this.getFnBComboReport;
      //         let tempCinemaArr = [];
      //         let dateArr = [];
      //         let obj = {};
      //         let dataArr = [];
      //         tempFnbRecords.map(x => {
      //           // let findCinemaIndex = tempCinemaArr.findIndex(i => {
      //           //   return i.cinema_id == x.cinema_id;
      //           // });
      //           let findDateIndex = dataArr.findIndex(d => {
      //             return d.cinema_id == x.cinema_id;
      //           });
      //           if (findDateIndex < 0) {
      //             let testArr = [];
      //             tempComboRecords.map(b => {
      //               testArr = b.fnbData.filter(d => {
      //                 return d.cinema_id == x.cinema_id;
      //               });
      //               return testArr;
      //             });
      //             dataArr.push({
      //               cinema_id: x.cinema_id,
      //               cinema_name: x.ft_cinema_name,
      //               addDateArr: testArr
      //             });
      //           }
      //           this.mainArr = dataArr;
      //         });
      //       } else {
      //         this.$toasted.show(data.message);
      //       }
      //     })
      //     .catch(this._CatchError)
      //     .finally(() => {
      //       setTimeout(() => loader.hide(), 660);
      //     });
      // },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    border: 1px solid black;
  }
  .swc-report-table th {
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .bg-lightblue {
    background-color: #3876d2 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/fnbComboSales.vue